// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_better_auth_organization_plugin_required26 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization plugin is required for organization-owned API keys.`)
};

const en_us2_better_auth_organization_plugin_required26 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization plugin is required for organization-owned API keys.`)
};

const de_de2_better_auth_organization_plugin_required26 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für organisationsbezogene API-Schlüssel ist das Organisations-Plugin erforderlich.`)
};

const en_better_auth_organization_plugin_required26 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization plugin is required for organization-owned API keys.`)
};

const de_better_auth_organization_plugin_required26 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für organisationsbezogene API-Schlüssel ist das Organisations-Plugin erforderlich.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const better_auth_organization_plugin_required26 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.better_auth_organization_plugin_required26(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("better_auth_organization_plugin_required26", locale)
	if (locale === "en-GB") return en_gb2_better_auth_organization_plugin_required26(inputs)
	if (locale === "en-US") return en_us2_better_auth_organization_plugin_required26(inputs)
	if (locale === "de-DE") return de_de2_better_auth_organization_plugin_required26(inputs)
	if (locale === "en") return en_better_auth_organization_plugin_required26(inputs)
	return de_better_auth_organization_plugin_required26(inputs)
};
export { better_auth_organization_plugin_required26 as "better-auth.ORGANIZATION_PLUGIN_REQUIRED" }